import { Action, State, types } from '.';

const initialState: State = {
    submitting: false,
    submitted: false,
    loading: false,
    paymentProducts: [],
    errorMessage: '',
    messageType: ''
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.ACTION_SERVER_DATA_PAYMENT_REQUESTED:
            return {
                ...state,
                submitting: true,
                submitted: false
            };

        case types.ACTION_SERVER_DATA_PAYMENT_FAILED:
            return {
                ...state,
                submitting: false,
                submitted: false,
                errorMessage: action.errorMessage,
                messageType: action.messageType
            };

        case types.SUBMIT_PAID_PRODUCTS_SUCCEED:
            return {
                ...state,
                submitting: false,
                submitted: true
            };

        case types.GET_PAYMENT_PRODUCTS_LOADING:
            return {
                ...state,
                loading: true
            };

        case types.GET_PAYMENT_PRODUCTS_FAILED:
            return {
                ...state,
                loading: false
            };

        case types.GET_PAYMENT_PRODUCTS_SUCCEED:
            return {
                ...state,
                loading: false,
                paymentProducts: action.paymentProducts
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/payment/reducer.ts